import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Select the lesson node to jump to',
  cancel: 'Cancel',
  accept: 'Accept',
  lessonNodes: 'Lesson node',
};

const welsh = {
  title: 'Ychwanegu cwestiwn ar gyfer eich ganghennau her',
  cancel: 'Canslo',
  accept: 'Derbyn',
  lessonNodes: 'Nodau gwers',
};

export const addJumpToWizardText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
